// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
} from "firebase/auth";
import { getFirestore, initializeFirestore, setLogLevel } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// 🔹 디버그 로그 활성화 (문제 해결용)
setLogLevel('debug');

// 🔹 Firebase 설정
const firebaseConfig = {
  apiKey: "AIzaSyCcOYMP3c-WWn-fvdT10dAYSbHUYNnPj-4",
  authDomain: "wiki-5d726.firebaseapp.com",
  projectId: "wiki-5d726",
  storageBucket: "wiki-5d726.firebasestorage.app",
  messagingSenderId: "888255286291",
  appId: "1:888255286291:web:3ee0473b3df7884c2503e6",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);

// 🔹 Firestore 초기화 (설정 단순화 & 디버깅)
// 로컬 캐시 이슈 배제를 위해 기본 캐시 사용, 롱폴링 유지
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

// 🔹 로그인 상태 유지 (비동기)
setPersistence(auth, browserLocalPersistence)
  .then(() => console.log("Persistence set to local"))
  .catch((err) => console.error("Persistence error:", err));

// 🔹 구글 로그인 함수
export const loginWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  try {
    const result = await signInWithPopup(auth, provider);
    console.log("로그인 성공:", result.user);
    return result.user;
  } catch (err) {
    console.error("로그인 실패:", err);
    return null;
  }
};

// 🔹 로그아웃 함수
export const logout = async () => {
  try {
    await signOut(auth);
    console.log("로그아웃 완료");
  } catch (err) {
    console.error("로그아웃 실패:", err);
  }
};

// 🔹 Auth 상태 구독 (React에서 바로 쓰기)
export const subscribeAuth = (callback) => {
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    callback(user);
  });
  return unsubscribe; // 필요시 구독 해제
};
